import * as api from 'src/api/previousVisitScoring';

import { getUrlParams } from '../helpers';

export const calculatePreviousVisitScoringForCurrentReading = async () => {
  const {
    id: clinicalTrialId,
    taskId: parentTaskId,
    subTaskId: taskId,
  } = getUrlParams() ?? {};

  if (!clinicalTrialId || !parentTaskId || !taskId) {
    throw new Error(
      'Cannot read the previous visit scoring: the reading route is not resolved'
    );
  }

  const { data } = await api.calculatePreviousVisitScoring({
    clinicalTrialId,
    parentTaskId,
    taskId,
  });

  return data;
};
